import { Grid } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from '../../../../../store'
import { MetricsActions } from '../../../../../store/TechnologyMetrics'
import { FundingGoalStats } from '../../Shared'
import { TotalMatchesCard } from './TotalMatchesCard'
import { TechGrantsActions } from '../../../../../store/technology'

export const GrantsDashboardStats = () => {
  const navigate = useNavigate()

  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(MetricsActions.fetchCurrentUserMatchedGrantsMetricsAsync())
  }, [dispatch])

  const handleMatchesNavigation = () => {
    dispatch(TechGrantsActions.resetData())
    navigate('/home/totalMatches')
  }

  return (
    <Grid mt={1} mb={2} container spacing={2}>
      <Grid
        item
        xs={12}
        sm={5}
        onClick={handleMatchesNavigation}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <TotalMatchesCard />
      </Grid>

      <Grid
        item
        xs={12}
        sm={7}
        onClick={() => navigate('/home/fundingGoals')}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <FundingGoalStats />
      </Grid>
    </Grid>
  )
}
